var map = {
	"./bfs/app/item-page/simple/field-components/file-section/file-section.component": [
		32714,
		"src_themes_bfs_app_item-page_simple_field-components_file-section_file-section_component_ts"
	],
	"./custom/app/item-page/simple/field-components/file-section/file-section.component": [
		38072,
		"src_themes_custom_app_item-page_simple_field-components_file-section_file-section_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78373;
module.exports = webpackAsyncContext;